// import React from "react";
// import { useLocation, useParams, Link } from "react-router-dom";

// export default function EventDetail() {
//   const { id } = useParams();
//   const location = useLocation();
//   const event = location.state?.event;

//   if (!event) {
//     return (
//       <div style={{ textAlign: "center", padding: "50px" }}>
//         <h2>Event not found</h2>
//         <Link to="/" style={{ color: "#0071bc" }}>
//           Back to Events
//         </Link>
//       </div>
//     );
//   }

//   return (
//     <div
//       style={{
//         maxWidth: "900px",
//         margin: "50px auto",
//         fontFamily: "Poppins, sans-serif",
//       }}
//     >
//       <img
//         src={event.image}
//         alt={event.title}
//         style={{
//           width: "100%",
//           height: "400px",
//           objectFit: "cover",
//           borderRadius: "10px",
//           marginBottom: "20px",
//         }}
//       />
//       <h2 style={{ color: "#074f86", marginBottom: "15px" }}>{event.title}</h2>
//       <p style={{ color: "#333", lineHeight: "1.6", fontSize: "16px" }}>
//         {event.description}
//       </p>

//       <Link
//         to="/"
//         style={{
//           display: "inline-block",
//           marginTop: "25px",
//           color: "#0071bc",
//           textDecoration: "none",
//           fontWeight: "600",
//         }}
//       >
//         ← Back to Events
//       </Link>
//     </div>
//   );
// }



import React from "react";
import { useLocation, useParams, Link } from "react-router-dom";

export default function EventDetail() {
  const { id } = useParams();
  const location = useLocation();
  const event = location.state?.event;

  if (!event) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <h2>Event not found</h2>
        <Link to="/" style={{ color: "#0071bc" }}>
          Back to Events
        </Link>
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "50px auto",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      {/* ⭐ 4 Images Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "15px",
          marginBottom: "20px",
        }}
      >
        {event.extraImages?.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`event-${index}`}
            style={{
              width: "100%",
              height: "250px",
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />
        ))}
      </div>

      <h2 style={{ color: "#074f86", marginBottom: "15px" }}>{event.title}</h2>
      <p style={{ color: "#333", lineHeight: "1.6", fontSize: "16px" }}>
        {event.description}
      </p>

      <Link
        to="/"
        style={{
          display: "inline-block",
          marginTop: "25px",
          color: "#0071bc",
          textDecoration: "none",
          fontWeight: "600",
        }}
      >
        ← Back to Events
      </Link>
    </div>
  );
}

